/* eslint-disable import/prefer-default-export */
import _ from 'lodash';

import * as types from '../action.types';
import createRule from '../../services/rule.service';

const applyRulesStart = () => ({
  type: types.APPLY_RULE_START,
});

const applyConversion = data => ({
  type: types.APPLY_CONVERSION,
  payload: data,
});

const applyRulesDone = () => ({
  type: types.APPLY_RULE_DONE,
});

const createNewRule = (text, attribute, active) => ({
  type: types.CREATE_NEW_RULE,
  payload: {
    text,
    attribute,
    active
  },
});

const updateRuleOrder = ruleArray => ({
  type: types.UPDATE_RULE_ORDER,
  payload: ruleArray,
});

const updateRuleActive = (id, active) => ({
  type: types.UPDATE_RULE_ACTIVE,
  payload: {
    id,
    active
  },
});

const deleteRule = id => ({
  type: types.DELETE_RULE,
  payload: id,
});

const updateRule = (id, text) => ({
  type: types.UPDATE_RULE,
  payload: {
    id,
    text
  },
});
export function executeRules() {
  return (dispatch, getState) => {
    dispatch(applyRulesStart());

    const data = getState().originalData;
    const customHeaders = _.filter(data, column => column.custom);
    const { currentSessionId, currentFileId } = getState().status;
    const currentFile = getState().sessions[currentSessionId].files[currentFileId];
    const headers = Object.keys(data);
    const rules = _.map(getState().rules.rules, (ruleDefinition) => {
      const { text, attribute, index, active } = ruleDefinition;
      const rule = createRule(text, attribute, active);
      rule.setIndex(index);
      return rule;
    });

    const globalRules = rules.filter(r => r.getAttribute() === '')
      .sort((a, b) => a.getIndex() - b.getIndex());

    const nonGlobalRules = rules.filter(r => r.getAttribute() !== '' && r.getAttribute() in data)
      .sort((a, b) => a.getIndex() - b.getIndex());

    const result = getState().originalData.map((row) => {
      const tempRow = { ...row };

      customHeaders.forEach((header) => {
        let rowData = '';
        header.value.forEach((value) => {
          rowData += tempRow[value] || '';

          if (header.value[header.value.length - 1] !== value) {
            rowData += header.separator;
          }
        });
        tempRow[header.key] = rowData;
      });

      let exclude = false;
      globalRules.forEach((rule) => {
        if(rule.active) {
          Object.keys(tempRow).forEach((column) => {
            tempRow[column] = rule.run(tempRow[column], headers, (key) => tempRow[key]);
          });
        }
      });

      nonGlobalRules.forEach((rule) => {
        if(rule.active && currentFile.rulesApplied ) {
        const attribute = rule.getAttribute();
        tempRow[attribute] = rule.run(tempRow[attribute], headers, (key) => tempRow[key]);
        if (rule.getRuleType() === 'EXCLUDE' && tempRow[attribute] === null) {
          exclude = true;
        }
      }
      });


      return exclude ? null : tempRow;
    }).filter(row => row !== null);
    dispatch(applyConversion(result));
    dispatch(applyRulesDone());
  };
}

export function createAndExecuteRule(text, attribute) {
  return (dispatch) => {
    dispatch(createNewRule(text, attribute,true));
    dispatch(executeRules());
  };
}
export function createAndExecuteRules(rules, attribute) {
  return (dispatch) => {
    for(var x = 0; x < rules.length; x++) {
      dispatch(createNewRule(rules[x], attribute));
    }
    dispatch(executeRules());
  };
}
export function updateRuleOrderAndExecuteRules(ruleArray) {
  const ruleArrayUpdatedIndexes = ruleArray.map((rule, index) => ({
    ...rule,
    index,
  }));

  return (dispatch) => {
    dispatch(updateRuleOrder(ruleArrayUpdatedIndexes));
    dispatch(executeRules());
  };
}

export function deleteAndExecuteRule(id) {
  return (dispatch) => {
    dispatch(deleteRule(id));
    dispatch(executeRules());
  };
}

export function updateRuleActiveState(id,active) {
  return (dispatch) => {
    dispatch(updateRuleActive(id,active));
    dispatch(executeRules());
  }
}
export function updateRuleText(id,text) {
  return (dispatch) => {
    dispatch(updateRule(id,text));
    dispatch(executeRules());
  }
}
